import { qAActionTypes } from './Constants';
import * as qaActions from './Actions';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { processRequest } from '../../services/Api';
import { overviewData, myQuestions, myAnswers, relatedQuestionsData } from './Selectors';
import * as errorHandlerActions from '../../components/errorHandler/Actions';

export default function* () {
	yield all([
		yield takeLatest(qAActionTypes.GET_QA_OVERVIEW, handleQAOverviewRequest),
		yield takeLatest(qAActionTypes.GET_MY_QUESTIONS, handleMyQuestionsRequest),
		yield takeLatest(qAActionTypes.GET_MY_ANSWERS, handleMyAnswersRequest),
		yield takeLatest(qAActionTypes.GET_HIW_RANKS, handleRanksRequest),
		yield takeLatest(qAActionTypes.GET_QUESTION_DETAILS, handleQuestionDetailsRequest),
		yield takeLatest(qAActionTypes.GET_RELATED_QUESTION, handleRelatedQuestionsRequest),
		yield takeLatest(qAActionTypes.UPVOTE_ANSWER, handleUpvoteAnswerRequest),
	]);
}

export function* handleQAOverviewRequest({ payload }) {
	try {
		const { data: queries } = payload || {};
		const { data } = yield call(processRequest, `public/qna/questions`, 'GET', queries);

		const formattedData = { ...data };

		if (queries && queries.offset) {
			const overview = yield select(overviewData);
			formattedData.results = [...overview.results, ...formattedData.results];
		}
		yield put(qaActions.getQAOverviewSuccess(formattedData));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(qaActions.getQAOverviewError());
	}
}

export function* handleMyQuestionsRequest({ payload }) {
	try {
		const { data: queries } = payload || {};
		const { data } = yield call(processRequest, `qna/my_questions`, 'GET', queries);

		const formattedData = { ...data };

		if (queries && queries.offset) {
			const currentData = yield select(myQuestions);
			formattedData.results = [...currentData.results, ...formattedData.results];
		}

		yield put(qaActions.getMyQuestionsSuccess(formattedData));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(qaActions.getMyQuestionsError());
	}
}

export function* handleMyAnswersRequest({ payload }) {
	try {
		const { data: queries } = payload || {};
		const { data } = yield call(processRequest, 'qna/my_answers', 'GET', queries);

		const formattedData = { ...data };

		if (queries && queries.offset) {
			const currentData = yield select(myAnswers);
			formattedData.results = [...currentData.results, ...formattedData.results];
		}

		yield put(qaActions.getMyAnswersSuccess(formattedData));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(qaActions.getMyAnswersError());
	}
}

export function* handleRanksRequest() {
	try {
		const { data } = yield call(processRequest, 'public/qna/ranks');

		yield put(qaActions.getRanksSuccess({ ranks: data.qna_ranks }));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(qaActions.getRanksError());
	}
}

export function* handleQuestionDetailsRequest({ payload }) {
	try {
		const {
			data: { questionId, reload },
		} = payload || {};

		const { data } = yield call(processRequest, `public/qna/questions/${questionId}`);
		yield put(
			qaActions.getQuestionDetailsSuccess({
				questionDetails: { ...data.qna_question, no_index: data.no_index },
			}),
		);
		if (!reload) yield put(qaActions.getRelatedQuestions({ questionId }));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e));
		yield put(qaActions.getQuestionDetailsError());
	}
}

export function* handleRelatedQuestionsRequest({ payload }) {
	try {
		const {
			data: { questionId, queries },
		} = payload || {};

		const { data } = yield call(
			processRequest,
			`public/qna/questions/${questionId}/related_questions`,
			'GET',
			queries,
		);

		const formattedData = {
			results: data.qna_questions,
			total_count: data.total_count,
			label: data.label,
		};

		if (queries && queries.offset) {
			const currentData = yield select(relatedQuestionsData);
			formattedData.results = [...currentData.results, ...formattedData.results];
		}

		yield put(
			qaActions.getRelatedQuestionsSuccess({
				relatedQuestions: formattedData,
			}),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'ignore'));
		yield put(qaActions.getRelatedQuestionsError());
	}
}

export function* handleUpvoteAnswerRequest({ payload }) {
	try {
		const {
			data: { answerId },
		} = payload || {};

		yield call(processRequest, `qna/answers/${answerId}/votes`, 'POST');
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'ignore'));
	}
}
